// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1959":"296416259ce9770a","3791":"be0230a76836c198","7997":"48435533e8fef4d0","8551":"51a431dd74c7eff4","9059":"f7fe6c2f5487881f","9365":"296416259ce9770a"}[chunkId] + ".css";
};